export const NAVBAR_TOOLTIP = {
  BACK: 'Back to Home',
  TOGGLE_BUTTON: 'Toggle Sidebar',
  NOTIFICATION: 'Notification',
  HELP: 'Help',
  LIGHT: 'Light Mode',
  DARK: 'Dark Mode',
  PROFILE: 'Profile',
};

export const PROFILE_TOOLTIP = {
  BACK: 'Back to Home',
};

export const REGISTER_TOOLTIP = {
  STEPPER: 'Click here to change previous details.',
};

export const ANNOTATION_TOOLTIP = {
  EDIT_LINK: 'Click here to edit this field',
  SAVE: 'Save',
  CLOSE: 'Close',
};

export const DOCUMENT_ACTION_TOOLTIP = {
  VALIDATE: 'Validate',
  EXPORT: 'Export',
  DELETE: 'Delete',
  RENAME_DOCUMENT: 'Rename Document',
  VIEW: 'View',
  TAGS: 'Tags',
  ASSIGN_TAG: 'Assign Tags',
  FILTER_APPLIED: 'filter is applied on tags column',
};

export const PAYMENT_ACTION_TOOLTIP = {
  DELETE: 'Delete Payment Invoice',
};
